import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Country } from './country.model';

@Injectable()
export class CountryFormService {
  constructor(private fb: FormBuilder) {}

  getForm(country: Country = new Country()): FormGroup {
    return this.fb.group({
      _id: [country._id],
      name: [country.name, Validators.required],
      code: [country.code, [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      active: [country.active]
    });
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/countries/shared/country-form.service.ts